export default "__VITE_ASSET__CYC3N0sj__"